export default __webpack_public_path__ + "static/media/BrainBreak cards35.0459bfb6.png";